<template>
  <div>
    <div class="container-title">
      {{ $t('purchase_orders.singular') }}
    </div>
    <b-card no-body>
      <b-card-body>
        <div class="row">
          <div class="col-12 col-md-6 col-xxl-4">
            <div class="row py-1">
              <div class="col-5 col-xxl-4 custom-label">
                {{ lodash.upperFirst($t('sale_notes.shows.date')) }}
              </div>
              <div class="col-1 custom-label">
                :
              </div>
              <div class="col-6 col-xxl-7 custom-value">
                {{ orderedAt }}
              </div>
            </div>
            <div class="row py-1">
              <div class="col-5 col-xxl-4 custom-label">
                {{ lodash.upperFirst($t('sale_notes.partner')) }}
              </div>
              <div class="col-1 custom-label">
                :
              </div>
              <div class="col-6 col-xxl-7 custom-value">
                {{ partnerName }}
              </div>
            </div>
          </div>
          <div class="col-12 col-md-6 col-xxl-6">
            <div class="row py-1">
              <div class="col-5 col-xxl-3 custom-label">
                {{ lodash.upperFirst($t('products.singular')) }}
              </div>
              <div class="col-1 custom-label">
                :
              </div>
              <div class="col-6 col-xxl-8 custom-value">
                {{ productServiceName }}
              </div>
            </div>
          </div>
          <div class="col-12">
            <div class="pb-1 pt-4">
              <b-table-simple class="resume-table" borderless outlined responsive>
                <b-thead>
                  <b-tr>
                    <b-th rowspan="2">No</b-th>
                    <b-th rowspan="2">{{ `${lodash.startCase($t('sale_notes.resumes.biomass'))} (${$t('units.kg')})` }}</b-th>
                    <b-th rowspan="2">{{ lodash.startCase($t('sale_notes.resumes.size')) }}</b-th>
                    <b-th colspan="2" style="text-align: center">{{ lodash.startCase($t('sale_notes.resumes.harvest_price')) }}</b-th>
                    <b-th colspan="2" style="text-align: center">{{ lodash.startCase($t('sale_notes.resumes.sell_price')) }}</b-th>
                  </b-tr>
                  <b-tr>
                    <b-th style="text-align: center">{{ `/${$t('units.kg')}` }}</b-th>
                    <b-th style="text-align: center">{{ lodash.startCase($t('sale_notes.resumes.total')) }}</b-th>
                    <b-th style="text-align: center">{{ `/${$t('units.kg')}` }}</b-th>
                    <b-th style="text-align: center">{{ lodash.startCase($t('sale_notes.resumes.total')) }}</b-th>
                  </b-tr>
                </b-thead>
                <b-tbody>
                  <b-tr v-for="({
                  quantity,
                  size,
                  purchase_price,
                  total_purchase_price,
                  sell_price,
                  total_sell_price,
                  },
                  index) in tableItems" v-bind:key="index">
                    <b-td>{{ index + 1 }}</b-td>
                    <b-td>{{ decimalFormatter(quantity) }}</b-td>
                    <b-td>{{ size }}</b-td>
                    <b-td style="text-align: center">{{ currencyFormatter(purchase_price) }}</b-td>
                    <b-td style="text-align: center">{{ currencyFormatter(total_purchase_price) }}</b-td>
                    <b-td style="text-align: center">{{ currencyFormatter(sell_price) }}</b-td>
                    <b-td style="text-align: center">{{ currencyFormatter(total_sell_price) }}</b-td>
                  </b-tr>
                </b-tbody>
                <b-tfoot>
                  <b-tr>
                    <b-td></b-td>
                    <b-td>{{ decimalFormatter(totalBiomass) }}</b-td>
                    <b-td></b-td>
                    <b-td></b-td>
                    <b-td style="text-align: center">{{ currencyFormatter(totalPurchasePrice)}}</b-td>
                    <b-td></b-td>
                    <b-td style="text-align: center">{{ currencyFormatter(totalSellPrice) }}</b-td>
                  </b-tr>
                </b-tfoot>
              </b-table-simple>
            </div>
          </div>
        </div>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
export default {
  name: 'purchase-order',
  props: {
    totalBox: {type: Number, default: 0},
    value: {type: Object, default: function () { return {} }},
  },
  computed: {
    purchaseOrder() {
      return this.value?.trip?.trip_items[0]  ?.purchase_item?.purchase_order ?? {}
    },
    orderedAt() {
      if (!this.purchaseOrder?.ordered_at) return '-'
      return this.$moment.utc(this.purchaseOrder.ordered_at).local().format('DD MMMM YYYY')
    },
    partnerName() {
      return this.purchaseOrder?.customer?.name ?? '-'
    },
    productServiceName() {
      return this.purchaseOrder?.product?.name ?? '-'
    },
    tableItems() {
      return this.value?.sale_items?.map(({
        trip_items,
        unit_price: sell_unit_price,
        total_price: total_sell_price,
      }) => {
        let {
          quantity,
          size,
          unit_price: purchase_price,
          total_price: total_purchase_price
        } = trip_items[0] ?? {}
        return {
          quantity: quantity,
          size: size,
          purchase_price: purchase_price,
          total_purchase_price: total_purchase_price,
          sell_price: sell_unit_price,
          total_sell_price: total_sell_price,
        }
      })
    },
    totalBiomass () {
      return this.value?.sale_item_total_initial_quantity ?? 0
    },
    totalPurchasePrice() {
      return this.tableItems.reduce((carry, {total_purchase_price}) => carry + total_purchase_price, 0)
    },
    totalSellPrice() {
      return this.value?.sale_item_total ?? 0
    }
  },
  methods: {
    currencyFormatter(value) {
      return this.$numeral(value).format('$ 0,0.[00]')
    },
    decimalFormatter(value) {
      return this.$numeral(value).format('0,0.[00]')
    },
    qualityFormatter(quality) {
      return ['fresh', 'merah'].includes(quality) ? this.lodash.upperFirst(quality) : this.lodash.upperCase(quality)
    }
  }
}
</script>

<style lang="scss" scoped>

</style>